module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-waterheating.svg?c4c19952678a99a54187da99b8ff3ae3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-waterheating.svg
// module id = 1052
// module chunks = 1